import { telegramAPI } from '@/api';
import * as types from './mutation-types';

export default {
  requestCode({ commit }, params) {
    commit(types.REQUEST_TELEGRAM_CODE_REQUEST);
    telegramAPI
      .get('api/auth', { params })
      .then(response => commit(types.REQUEST_TELEGRAM_CODE_SUCCESS, response.data))
      .catch(error => commit(types.REQUEST_TELEGRAM_CODE_FAILURE, error));
  },

  confirmCode({ commit }, payload) {
    commit(types.SIGN_IN_TELEGRAM_REQUEST);
    telegramAPI
      .get('api/confirm', { params: payload })
      .then(response => commit(types.SIGN_IN_TELEGRAM_SUCCESS, response.data))
      .catch(error => commit(types.SIGN_IN_TELEGRAM_FAILED, error));
  },

};



// WEBPACK FOOTER //
// ./src/store/modules/telegram/actions.js